import { createFileRoute } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';
import { z } from 'zod';
import { getActiveSupplyPoint } from '@/features/supply-points/utils/resolveActiveSupplyPoint.ts';
import { telemetryQueries } from '@/features/telemetry/queries';
import { OverviewPageSkeleton } from '@/common/components/loading-skeleton/OverviewPageSkeleton';
import { OverviewPage } from '@/features/telemetry/pages/OverviewPage';

const overviewSearchSchema = z.object({
  preset: z.enum(['6h', '24h', '7d']).optional(),
  from: z.iso.datetime({ offset: true }).optional(),
  to: z.iso.datetime({ offset: true }).optional(),
});

export const Route = createFileRoute('/_authenticated/_supply-point-scope/')({
  validateSearch: overviewSearchSchema,
  loader: async ({ context: { queryClient } }) => {
    const activeSupplyPoint = await getActiveSupplyPoint(queryClient);

    if (activeSupplyPoint) {
      await queryClient.ensureQueryData(telemetryQueries.fields(activeSupplyPoint.id));
    }

    return {
      breadcrumb: t`Overview`,
    };
  },
  pendingComponent: OverviewPageSkeleton,
  component: function OverviewRoute() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();

    return (
      <OverviewPage
        search={search}
        onSearchChange={(next) => navigate({ search: next, replace: true })}
      />
    );
  },
});
